export default "__VITE_ASSET__D7Sfjz94__"